export default __webpack_public_path__ + "static/media/right_tick_img.da72d17f.svg";